import React, { FC } from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { Sync as SyncIcon, Search as SearchIcon, FindReplace as FindReplaceIcon } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import {
  foreColor,
  foreColorCode,
  foreColorCodeOnMouseOver,
  foreColorOnMouseOver,
} from "../../../../commons/colors";
import { useRecoilValue } from "recoil";
import { userState } from "../../../../states/userState";

type Props = {
  disabled: boolean;
  onClick: () => void;
  caption: string;
};
export const FetchButton: FC<Props> = ({ disabled, onClick, caption }) => {
  const user = useRecoilValue(userState);
  const getStyles = () => {
    let styles = {
      backgroundColor: foreColorCode(user?.mode ?? "lite"),
      color: "#000",

      fontSize: 16,
      height: 30,
      // marginBottom: 16,
      width: 30,
      boxShadow: "3px 3px 8px 1px #202226",
      transition: "all 0.3s",
      "&:hover": {
        backgroundColor: foreColorCodeOnMouseOver(user?.mode ?? "lite"),
        color: "#37393F",
        boxShadow: "none",
        transform: "translate(3px, 3px)",
      },
    };
    return styles;
  };
  return (
    <IconButton
      component="label"
      disabled={disabled}
      onClick={onClick}
      sx={getStyles()}
    >
      <Tooltip title={caption} placement="right">
        <FindReplaceIcon />
      </Tooltip>
    </IconButton>
  );
};
